// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { cva } from 'cva';
import React from 'react';
import { Body } from "../Typography";
import { cn } from "../../common/utils";
import { Icon } from "../Icon";
import * as icons from "../../icons";

// Type guard function to validate IconType
var isIconType = function isIconType(icon) {
  return typeof icon === 'string' && Object.keys(icons).includes(icon);
};
var chipStyles = cva({
  base: 'cop-inline-flex cop-items-center cop-justify-center cop-gap-1.5 cop-rounded-[4px] cop-border cop-border-solid cop-box-border',
  variants: {
    variant: {
      "default": 'hover:cop-bg-[#F8F9FB] active:cop-bg-secondary cop-border-transparent',
      outlined: 'hover:cop-bg-[#F8F9FB] active:cop-bg-secondary cop-border-secondary',
      filled: 'cop-bg-secondary hover:cop-bg-input-gray active:cop-bg-[#C9CBCD] focus:cop-bg-secondary'
    },
    size: {
      lg: 'cop-px-3 cop-h-10',
      md: 'cop-px-3 cop-py-0.5',
      sm: 'cop-px-2 cop-py-0.5'
    },
    disabled: {
      "true": 'cop-pointer-events-none'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'sm',
    disabled: false
  },
  compoundVariants: [{
    variant: 'default',
    disabled: true,
    "class": 'cop-bg-[#F8F9FB] cop-text-gray-300'
  }, {
    variant: 'outlined',
    disabled: true,
    "class": 'cop-bg-[#F8F9FB] cop-text-gray-300'
  }, {
    variant: 'filled',
    disabled: true,
    "class": 'cop-text-disabled cop-border-[#DFE1E4]'
  }, {
    variant: 'filled',
    disabled: false,
    "class": 'cop-border-transparent'
  }]
});
var chipIconStyles = cva({
  variants: {
    size: {
      sm: 'cop-h-[11px] cop-w-[11px]',
      md: 'cop-h-3 cop-w-3',
      lg: 'cop-h-3 cop-w-3'
    }
  },
  defaultVariants: {
    size: 'sm'
  }
});
var RenderIcon = function RenderIcon(_ref) {
  var icon = _ref.icon,
    className = _ref.className;
  if (!icon) {
    return null;
  }
  if (typeof icon === 'string' && isIconType(icon)) {
    return /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      className: className
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, icon);
};
export var Chip = function Chip(_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'default' : _ref2$variant,
    label = _ref2.label,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'sm' : _ref2$size,
    className = _ref2.className,
    prefixIcon = _ref2.prefixIcon,
    disabled = _ref2.disabled,
    onClick = _ref2.onClick,
    onClose = _ref2.onClose,
    ariaPressed = _ref2['aria-pressed'];
  var handleClose = function handleClose(e) {
    e.stopPropagation();
    onClose === null || onClose === void 0 || onClose(e);
  };

  // Conditionally set wrapper props based on whether onClick is provided
  var wrapperProps = _objectSpread({
    className: cn(chipStyles({
      variant: variant,
      size: size,
      disabled: disabled
    }), {
      'cop-cursor-pointer focus:cop-outline-none focus:cop-outline-[1.5px] focus:cop-outline-offset-[1px] focus:cop-outline-primary': onClick
    }, {
      'cop-cursor-default hover:cop-bg-transparent cop-text-primary active:cop-bg-white': !onClick
    }, className)
  }, onClick && {
    'aria-disabled': disabled,
    role: 'button',
    tabIndex: disabled ? -1 : 0,
    onClick: disabled ? undefined : onClick,
    'aria-pressed': ariaPressed
  });
  return /*#__PURE__*/React.createElement("div", wrapperProps, /*#__PURE__*/React.createElement(RenderIcon, {
    icon: prefixIcon,
    className: chipIconStyles({
      size: size
    })
  }), /*#__PURE__*/React.createElement(Body, {
    size: size !== 'sm' ? 'base' : 'sm'
  }, label), Boolean(onClose) ?
  /*#__PURE__*/
  // We intentionally attach both onClick and onTouch event
  // handler to make sure click event are supported in
  // both mobile and desktop. e.g. in react-select
  // component, without having a touch event handler
  // it will not remove the chip when clicking on the close icon
  // in mobile.
  React.createElement("span", {
    onClick: handleClose,
    onTouchEnd: handleClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "Close",
    className: chipIconStyles({
      size: size
    })
  })) : null);
};
